enum RejectionTypeCd {
  PRIMARY_RESIDENCE = 'PRIMARY_RESIDENCE',
  PRIMARY_RESIDENCE_02 = 'PRIMARY_RESIDENCE_02',
  IDENTITY = 'IDENTITY',
  SHUOL = 'SHUOL',
  CITY_DEBT = 'CITY_DEBT',
  REVOKED = 'REVOKED',
}

export default RejectionTypeCd;
